import { FC } from "react";
import { RouteComponentProps } from "react-router-dom";
import styled from 'styled-components';

import tavernLogoImg from '../images/tavernLogo.jpg';

import { WatchAppButton } from '../component/WatchAppButton';

import { DynamicLinkBuilder } from "../store/DynamicLinkBuilder";

type Props = {} & RouteComponentProps<{
    castId: string;
}>;

const TavernLogo = styled.img`
    width: 120px;
    margin: 20px;
`
const Text = styled.div`
    margin: 15px;
`

export const PrivateListenPage: FC<Props> = (props:Props) =>{
    const castId = props.match.params.castId
    const dynamicLink = new DynamicLinkBuilder(castId,"web_private_listen").getUrl()
    console.log(dynamicLink.toString())
    return (
        <>
            <TavernLogo src={tavernLogoImg}/>
            <Text>非公開キャストの為、Webでは視聴できません。
            相互フォローになるとキャストを聞く事ができます。</Text>
            <WatchAppButton transitionLink={dynamicLink.toString()} />
        </>
    )
}